import { render, staticRenderFns } from "./DialogListaProdutos.vue?vue&type=template&id=5b554390"
import script from "./DialogListaProdutos.vue?vue&type=script&lang=js"
export * from "./DialogListaProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports